import { toastError } from '@/helpers/helpers'

export default {
  props: {
    state: {
      type: Object | String
    },

    submitting: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    state(val) {
      this.errors = this.makeServerErrors(val)
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  computed: {
    isValid() {
      return !Object.keys(this.errors).length
    }
  },

  methods: {
    isValidField(name) {
      let valid = true
      if (Array.isArray(name)) {
        name.forEach(n => {
          const error = this.errors[n]
          valid = valid && (!error || !error.length)
        })
      } else {
        const error = this.errors[name]
        valid = (!error || !error.length)
      }

      return valid ? undefined : false
    },

    getErrors(fields) {
      return fields.reduce((out, field) => { return out.concat(this.errors[field] || []) }, [])
    },

    toast(errors) {
      toastError(this, errors)
    },

    makeServerErrors(errors) {
      if (typeof errors === 'string') {
        if (errors) {
          this.toast(errors)
        }
        return {}
      } else {
        return errors
      }
    },

    validate() { },

    prepare(data) {
      return { ...data }
    },

    onSubmit() {
      this.errors = this.validate(this.form) || {}
      if (this.isValid) {
        this.$emit('submit', this.prepare(this.form))
      }
    }
  }
}
